import { apiClient } from '~/api/client';

export type FavoriteListParams = {
  listId: number;
};

export const destroy = async ({ listId }: FavoriteListParams) =>
  apiClient.delete(`/favorite_lists/${listId}`);

export const create = async ({ listId }: FavoriteListParams) =>
  apiClient.post(`/favorite_lists?list_id=${listId}`);
